import { createAction } from 'redux-actions'
import { IS_APPLICATION_LOADING } from '../../actions/types'
import apiPrd from '../../services/apiPrd'
import * as types from './types'

const fetchNotices = async () => {
  const res = await apiPrd.get('/notices')
  return res.data
}
export const getNotices = () => (dispatch) => {
  dispatch(createAction(IS_APPLICATION_LOADING)(true))
  fetchNotices().then((res) => {
    dispatch(createAction(types.GET_NOTICES)(res))
  }).catch(err => console.log(err)).finally(() => dispatch(createAction(IS_APPLICATION_LOADING)(false)))
}
